import { useMutation } from '@tanstack/react-query'
import { postNamedCommand } from '../../../../../../service'

export const useArchiveInfographicTemplateMutation = () => {
  return useMutation({
    mutationFn: async ({ infographicTemplateId }) => {
      const { data } = await postNamedCommand('reports', 'archive-infographic-template', { infographicTemplateId })
      return data
    }
  })
}
